import { Checkbox, Field, Label } from '@headlessui/react';
import React from 'react';

type Props = {
  label?: React.ReactNode;
  enabled: boolean;
  setEnabled: () => void;
};

export const CheckBox = ({ label, enabled, setEnabled }: Props) => {
  return (
    <Field className="flex items-center gap-2">
      <Checkbox
        checked={enabled}
        onChange={setEnabled}
        className="group block size-4 rounded border-2 border-gray-400 bg-white data-[checked]:bg-blue-500"
      >
        <svg
          className="stroke-white opacity-0 group-data-[checked]:opacity-100"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M3 8L6 11L11 3.5"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Checkbox>
      {label && <Label>{label}</Label>}
    </Field>
  );
};
